import { Link } from "react-router-dom";
import { InstagramLogo, TwitterLogo, FacebookLogo } from "@phosphor-icons/react";

const LOGO = "/ticketup_logo.png";

export default function Footer() {
  return (
    <footer className="bg-[#0A0A0A] dark:bg-[#030712] text-white mt-24" data-testid="footer">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-20 lg:py-28">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <h2 className="font-display text-5xl md:text-7xl leading-none tracking-tighter">
              Live happens. <br />
              <span className="brand-gradient">Be there.</span>
            </h2>
            <p className="mt-6 text-neutral-400 max-w-md text-base">
              The most trusted ticket platform in Bangladesh. Discover and buy tickets for the events that matter.
            </p>
          </div>

          <div className="md:col-span-2">
            <p className="label-eyebrow text-neutral-500">Discover</p>
            <ul className="mt-4 space-y-2 text-sm">
              <li><Link to="/events?category=concerts" className="hover:text-[#9333EA]">Concerts</Link></li>
              <li><Link to="/events?category=sports" className="hover:text-[#9333EA]">Sports</Link></li>
              <li><Link to="/events?category=festivals" className="hover:text-[#9333EA]">Festivals</Link></li>
              <li><Link to="/events?category=theater" className="hover:text-[#9333EA]">Theater</Link></li>
              
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="label-eyebrow text-neutral-500">Sell</p>
            <ul className="mt-4 space-y-2 text-sm">
              <li><Link to="/organizer" className="hover:text-[#9333EA]">Become an organizer</Link></li>
              
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="label-eyebrow text-neutral-500">Support</p>
            <ul className="mt-4 space-y-2 text-sm">
              <li>support@ticketup.com</li>
              <li>+880 1700 000 000</li>
              <li>Dhaka, Bangladesh</li>
            </ul>
            <div className="mt-6 flex items-center gap-4">
              <InstagramLogo size={22} className="hover:text-[#9333EA] cursor-pointer" />
              <TwitterLogo size={22} className="hover:text-[#9333EA] cursor-pointer" />
              <FacebookLogo size={22} className="hover:text-[#9333EA] cursor-pointer" />
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between gap-4 text-xs text-neutral-500">
          <div className="flex items-center gap-3">
            <img src={LOGO} alt="TicketUp" className="h-7 w-auto invert brightness-0 [filter:brightness(0)_invert(1)]" />
            <span>© 2026 TicketUp. All rights reserved.</span>
          </div>
          <div className="flex gap-6">
            <span>Privacy</span>
            <span>Terms</span>
            <span>Fraud Protection</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
